import React from 'react';
import { data } from '../../constants';

import './Laurels.css';

const Laurels = () => (


  <div className='app__laurels section__padding' id='skills'>
    <div className='app__laurels_info'>
      <h1 className='headtext__cormorant'>Skills</h1>
    </div>

    <div className='app__laurels-technologies'>
      {data.technologies.map((technology) => (
        <a href={technology.link} target="_blank" rel="noopener noreferrer">
          <div className='app__laurels-technologies_card' key={technology.technology}>
            <img src={technology.image} alt={technology.technology} />
            <p className='p__opensans'>{technology.technology}</p>
          </div>
        </a>
      ))}

    </div>
  </div>
);

export default Laurels;
